import axios from "axios";
import { isDemo } from "config/env";

const PROJECT_ID = "f5rve607";

const DATASET = isDemo ? "demo" : "production";

// Shop V3 follows the same rule as the legacy shop pages: only the demo
// environment reads the demo dataset (and backendPlan.demoId); dev,
// stage, and production all read the production dataset (and prodId).
export const shopV3Dataset = DATASET;

// use HTTP instead of sanityClient because createClient from @sanity/client is giving error
export const client = {
  fetch: (query: string, dataset: string = DATASET) =>
    axios(
      `https://${PROJECT_ID}.api.sanity.io/v2021-06-07/data/query/${dataset}?`,
      {
        params: {
          query,
        },
      },
    ).then((response) => response.data),
};

export const getSanityImage = (ref: string, dataset: string = DATASET) => {
  const [_, id, dimension, format] = ref.split("-");
  return `https://cdn.sanity.io/images/${PROJECT_ID}/${dataset}/${id}-${dimension}.${format}`;
};

export const getImageDimention = (ref: string) => {
  const [_, __, dimensionS] = ref.split("-");
  const [width, height] = dimensionS.split("x").map((v) => parseInt(v, 10));

  return { width, height };
};
